import React, { useState, useEffect } from 'react';
import axios from "axios";

export default function RequestorInfo({ requestorId, requestorType, legislatureId }) {
    const [requestorInfo, setRequestorInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    async function fetchNonStandingCommitteeData(nonStandingCommitteeId, legislatureId) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/nonStandingCommittees/search?limit=500&offset=0`,
                {
                    nonStandingCommitteeIds: [nonStandingCommitteeId],
                    legislatureIds: [legislatureId]
                },
                {
                    headers: {
                        'accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching committee data: ", error);
            throw error;
        }
    }

    async function fetchStandingCommitteeData(StandingCommitteeId, legislatureId) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/standingCommittees/search?limit=500&offset=0`,
                {
                    standingCommitteeIds: [StandingCommitteeId],
                    legislatureIds: [legislatureId]
                },
                {
                    headers: {
                        'accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching committee data: ", error);
            throw error;
        }
    }

    async function fetchLegislatorData(requestorId) {
        try {
            const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/legislators/${requestorId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching bill draft legislator data: ", error);
        }
    }

    async function fetchAgencyData(requestorId) {
        try {
            const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/organizations/${requestorId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching bill draft agency data: ", error);
        }
    }

    async function fetchElectedOfficialData(requestorId) {
        try {
            const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/electedOfficialPositions/${requestorId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching bill draft agency data: ", error);
        }
    }

    async function fetchBillRequestor(requesterId, requestorType) {
        let requesterData;
        try {
            if (requestorType === "AGENCY" || requestorType === "AGENCY_ON_BEHALF_OF_NON_STANDING_COMMITTEE" || requestorType === "AGENCY_ON_BEHALF_OF_STANDING_COMMITTEE") {
                requesterData = await fetchAgencyData(requesterId);
            } else if (requestorType === "ELECTED_OFFICIAL_POSITION") {
                requesterData = await fetchElectedOfficialData(requesterId);
            } else if (requestorType === "NON_STANDING_COMMITTEE") {
                requesterData = await fetchNonStandingCommitteeData(requesterId, 2);
            } else if (requestorType === "STANDING_COMMITTEE") {
                requesterData = await fetchStandingCommitteeData(requesterId, 2);
            } else if (requestorType === "LEGISLATOR") {
                requesterData = await fetchLegislatorData(requesterId);
            }
            return { requesterData };
        } catch (error) {
            console.error("Error in fetchBillRequestor: ", error);
            throw error;
        }
    }

    useEffect(() => {
        async function loadRequestorInfo() {
            try {
                const data = await fetchBillRequestor(requestorId, requestorType);
                setRequestorInfo(data.requesterData);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        }

        loadRequestorInfo();
    }, [requestorId, requestorType]);

    if (loading) return <span>Loading...</span>;
    if (error) return <span>Error: {error.message}</span>;
    if (!requestorInfo) return <span>{requestorId}</span>;

    const formatRequestorInfo = (requestorInfo) => {
        if (!requestorInfo) return 'N/A';

        const { content, name, firstName, lastName } = requestorInfo;

        if (content?.[0]?.committeeDetails?.committeeCode?.name) {
            return content[0].committeeDetails.committeeCode.name;
        }

        if (name) return name;

        if (lastName || firstName) {
            return `${lastName || ''}, ${firstName || ''}`.trim();
        }

        return 'N/A';
    };

    return formatRequestorInfo(requestorInfo);

}